import { fmtDateTime } from "./portalUtils";

export function ClientTimeline({ entries = [] }) {
  if (!entries.length) return <p className="text-xs text-muted-foreground">No activity yet.</p>;
  const sorted = [...entries].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
  return (
    <ol className="relative border-l border-border ml-2 space-y-4" data-testid="client-timeline">
      {sorted.map((t) => (
        <li key={t.id || t.created_at} className="ml-4" data-testid="timeline-entry">
          <span className={`absolute -left-[5px] mt-1.5 h-2.5 w-2.5 rounded-full ${t.user_role === "client" ? "bg-primary" : "bg-emerald-500"}`} />
          <p className="text-xs leading-snug">{t.description}</p>
          <p className="text-[10px] text-muted-foreground mt-0.5">{fmtDateTime(t.created_at)}{t.user_name ? ` · ${t.user_name}` : ""}</p>
        </li>
      ))}
    </ol>
  );
}
